'use strict';
import { TweenLite, CSSPlugin } from "gsap/all";
const plugins = [CSSPlugin];

export default class GrantSelectionScreen {
    constructor() {
        this.name = 'GrantSelectionScreen';

        if (document.querySelector("#grantSelectionForm")) {

            d.querySelector("button.g-button").classList.add("disabled");//DRAFT
            d.querySelector("input.g-button").classList.add("disabled");//SUBMIT

            const draftReqList = [
                "#OrganizationName",
                "#Street",
                "#City",
                "#StateId",
                "#ZipCode"
            ];


            const contactList = [
                "#ContactFirstName",
                "#ContactLastName",
                "#ContactPhoneNumber",
            ];

            const submitReqList = [
                "#OrganizationName",
                "#Street",
                "#City",
                "#StateId",
                "#ZipCode",
                "#OrgEmail",
                "#ContactFirstName",
                "#ContactLastName",
                "#ContactPhoneNumber",
                "#TaxId"
            ];

          

            const validateForm = (currentField) => {
                let isDraftValid = true;
                let contactstarted = false;


                if (currentField) {
                    currentField.classList.add("entered");
                }
                submitReqList.forEach((input) => {
                    d.querySelector(input).classList.remove("error");
                });

                contactList.forEach((input) => {
                    d.querySelector(input).classList.remove("error");
                });



                draftReqList.forEach((field) => {
                    const _f = d.querySelector(field);
                    if (!_f.value) {
                        isDraftValid = false;

                        if (_f.classList.contains("entered")) {
                            _f.classList.add("error");
                        }
                    }

                    if (field == "#ZipCode") {
                        var reg = new RegExp(/^\d{5}(-\d{4})?$/);
                        if (!reg.test(_f.value)) {
                            isDraftValid = false;

                            if (_f.classList.contains("entered")) {
                                _f.classList.add("error");
                            }
                        }
                    }
                });

          

                contactList.forEach((itemm) => {
                    const field = d.querySelector(itemm);
                    if (field.value ) {
                        contactstarted = true;

                        console.log("contactstarted:: ", contactstarted);
                    }
                });



                if (contactstarted) {
                    console.log("validating contact fields:: ");
                    contactList.forEach((field) => {
                        const _f = d.querySelector(field);
                        if (!_f.value) {
                            isDraftValid = false;

                            if (_f.classList.contains("entered")) {
                                _f.classList.add("error");
                            }
                        }

                        if (field == "#ContactPhoneNumber") {
                            var reg = new RegExp(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/);
                            if (!reg.test(_f.value)) {
                                isDraftValid = false;
                                if (_f.classList.contains("entered")) {
                                    _f.classList.add("error");
                                }
                            }
                        }
                    });

                }




                if (isDraftValid) {
                    d.querySelector("button.g-button").classList.remove("disabled");//DRAFT
                } else {
                    d.querySelector("button.g-button").classList.add("disabled");//DRAFT

                }


                let isSubmitValid = true;
                submitReqList.forEach((field) => {
                    const _f = d.querySelector(field);
                    if (!_f.value) {
                        isSubmitValid = false;
                        if (_f.classList.contains("entered")) {
                            _f.classList.add("error");
                        }
                    }

                    if (field == "#ZipCode") {
                        var reg = new RegExp(/^\d{5}(-\d{4})?$/);
                        if (!reg.test(_f.value)) {
                            isSubmitValid = false;
                            if (_f.classList.contains("entered")) {
                                _f.classList.add("error");
                            }
                        }
                    }


                    if (field == "#OrgEmail") {
                        var reg = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
                        if (!reg.test(_f.value)) {
                            isSubmitValid = false;
                            if (_f.classList.contains("entered")) {
                                _f.classList.add("error");
                            }
                        }
                    }
                    if (field == "#ContactPhoneNumber") {
                        var reg = new RegExp(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/);
                        if (!reg.test(_f.value)) {
                            isSubmitValid = false;
                            if (_f.classList.contains("entered")) {
                                _f.classList.add("error");
                            }
                        }
                    }

                    //if (field == "#TaxId") {
                    //    if (_f.value > 12) {
                    //        isSubmitValid = false;
                    //        if (_f.classList.contains("entered")) {
                    //            _f.classList.add("error");
                    //        }
                    //    }
                    //}
                });

                if (isSubmitValid) {
                    d.querySelector("input.g-button").classList.remove("disabled");//DRAFT
                } else {
                    d.querySelector("input.g-button").classList.add("disabled");//DRAFT

                }

            }

            submitReqList.forEach((input) => {
                d.querySelector(input).addEventListener("change", (e) => {
                    validateForm(e.currentTarget);
                });
            });

            submitReqList.forEach((field) => {
            
                const fieldEl = d.querySelector(field);
                if (fieldEl.value && fieldEl.value.length >= 1) {
                    fieldEl.classList.add('entered');
                }
            });

            validateForm();
        }
    }
}